import { render, staticRenderFns } from "./Magiun3.vue?vue&type=template&id=21508f26&scoped=true&"
import script from "./Magiun3.vue?vue&type=script&lang=js&"
export * from "./Magiun3.vue?vue&type=script&lang=js&"
import style0 from "./Magiun3.vue?vue&type=style&index=0&id=21508f26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21508f26",
  null
  
)

export default component.exports